import classes from '../pages/destinations/destinations.module.scss'
import Link from 'next/link'
import Button from '../button'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useQuery } from '@apollo/client'
import { SEARCH_TAGS } from '../../lib/queries'
import { SearchContext } from '../../lib/context/search-context'
import config from '../../config'
import PropTypes from 'prop-types'

const Filters = ({ types, areas, onClose }) => {
  const { t, i18n } = useTranslation()
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const [filterTypes, setFilterTypes] = useState(
    searchParams.filterType.length > 0 ? searchParams.filterType : []
  )
  const [categorisedFilter, setCategoriedFilter] = useState({})
  const [filterAreas, setFilterAreas] = useState(
    searchParams.filterArea.length > 0 ? searchParams.filterArea : []
  )

  useEffect(() => {
    const filtered = types.filter((type) => {
      return type.search_filter_category !== null
    })
    const categories = {}
    for (const filter of filtered) {
      if (categories.hasOwnProperty(filter.search_filter_category.name)) {
        categories[filter.search_filter_category.name].push(filter)
      } else {
        categories[filter.search_filter_category.name] = [filter]
      }
    }
    setCategoriedFilter(categories)
  }, [])

  const changeTypes = (event) => {
    if (event.currentTarget.checked) {
      const selectedType = types.filter(
        (type) => type.name === event.currentTarget.value
      )
      setFilterTypes([...filterTypes, ...selectedType])
    } else {
      setFilterTypes(
        filterTypes.filter((type) => type.name !== event.currentTarget.value)
      )
    }
    // setSearchParameters({...searchParams, filterType: [...filterTypes]}, 0, config.cookieOptions)
  }
  const changeAreas = (event) => {
    if (event.currentTarget.checked) {
      const selectedArea = areas.filter(
        (area) => area.name === event.currentTarget.value
      )
      setFilterAreas([...filterTypes, ...selectedArea])
    } else {
      setFilterAreas(
        filterAreas.filter((area) => area.name !== event.currentTarget.value)
      )
    }
    // setSearchParameters({...searchParams, filterArea: [...filterAreas]}, 0, config.cookieOptions)
  }

  const showResults = () => {
    setSearchParameters(
      {
        ...searchParams,
        filterType: filterTypes,
        filterArea: filterAreas,
      },
      0,
      config.cookieOptions
    )
    onClose()
  }
  const clearFilters = () => {
    setFilterAreas([])
    setFilterTypes([])
    // onClose()
  }
  return (
    <>
      <div className={classes.popup}>
        {Object.entries(categorisedFilter).map(([key], i) => {
          return (
            <React.Fragment key={i}>
              <div className={classes.popupLabel}>{key}</div>
              <div className={classes.popupOptions}>
                {categorisedFilter[key].map((filter, i) => {
                  const isSelected = filterTypes.filter(
                    (fType) => fType.name == filter.name
                  )
                  return (
                    <label key={i}>
                      <input
                        type="checkbox"
                        value={filter.name}
                        onClick={changeTypes}
                        checked={isSelected.length == 1}
                      />{' '}
                      {filter.name}
                    </label>
                  )
                })}
              </div>
            </React.Fragment>
          )
        })}
      </div>
      <div className={classes.buttonWrapper}>
        <span
          onClick={clearFilters}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          Reset filters
        </span>
        <Button
          width={'140px'}
          color={'green'}
          size={'small'}
          onClick={showResults}
        >
          <span>{t('Show results')}</span>
        </Button>
      </div>
    </>
  )
}
Filters.propTypes = {
  onClose: PropTypes.func.isRequired,
  types: PropTypes.array,
  areas: PropTypes.array,
}
export default Filters
